import classNames from "classnames";
import styles from "./index.module.scss";
import ProfileIcon from "../ProfileIcon";
import RoleLabel from "../RoleLabel";
import { Text, Heading } from "../../Type";
import TextLink from "../../TextLinks";

type PropsType = {
  size: "small" | "medium" | "large";
  user: { first_name: string; last_name: string; role: { name: string } };
  userRole?: boolean;
  description?: string;
  edit?: string;
  editTo?: string;
};

const ProfilePreview = ({
  size,
  user,
  description,
  userRole,
  edit,
  editTo,
}: PropsType) => {
  const name = `${user.first_name} ${user.last_name}`;

  return (
    <div
      className={classNames(styles.grid, {
        [styles.gridSmall]: size === "small",
        [styles.gridMedium]: size === "medium",
        [styles.gridLarge]: size === "large",
      })}
    >
      <div className={styles.profileIcon}>
        <ProfileIcon name={name} userRole={user.role.name} size={size} />
      </div>
      <div className={styles.content}>
        <div
          className={classNames(styles.name, {
            [styles.nameSmall]: size === "small",
            [styles.nameMedium]: size === "medium",
            [styles.nameLarge]: size === "large",
          })}
        >
          {size === "large" ? (
            <Heading component="h3" size="h3">
              {name}
            </Heading>
          ) : (
            <Text size="small" weight="bold">
              {name}
            </Text>
          )}
          {edit && editTo && (
            <div className={styles.edit}>
              <TextLink to={editTo}>{edit}</TextLink>
            </div>
          )}
        </div>
        {userRole && size !== "small" && (
          <div className={styles.userRole}>
            <RoleLabel userRole={user.role.name} />
          </div>
        )}
        {description && size !== "small" && (
          <Text size="small" className={styles.userDescription}>
            {description}
          </Text>
        )}
      </div>
    </div>
  );
};

export default ProfilePreview;
